import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { useParams } from 'react-router-dom';
import { CompetingClaimsSnapshot } from '../../components/CompetingClaimsSnapshot';
import { DraftRegistrationSnapshot } from '../../components/DraftRegistrationSnapshot';
import { EmbeddedWorkflowView } from '../../components/EmbeddedWorkflowView';
import HomeActions from '../../components/HomeActions';
import IfFeatureEnabledMSR3 from '../../components/IfFeatureEnabledMSR3';
import { PageHeader } from '../../components/PageHeader';
import { PotentialClaimsSnapshot } from '../../components/PotentialClaimsSnapshot';
import ProtectElement from '../../components/ProtectElement';
import { TitlesSnapshot } from '../../components/TitlesSnapshot';
import { FEATURE_FLAGS } from '../../constant/featureFlags';
import { useActiveWorkspace } from '../../hooks/useActiveWorkspace';
import { useEmbeddedWorkflowActive } from '../../hooks/useEmbeddedWorkflowActive';
import { MSR3BaseLayout } from '../../layout/MSR3BaseLayout';
import { AlertConfirmClientsForWorkspace } from '../Dashboard/Alerts/AlertConfirmClientsForWorkspace';
import { AlertForUnverifiedBusinessNumber } from '../Dashboard/Alerts/AlertForUnverifiedBusinessNumber';
import { AlertOnboarding } from '../Dashboard/Alerts/AlertOnboarding';
import { AlertTermsConditions } from '../Dashboard/Alerts/AlertTermsConditions';

/**
 * MSR3 Home page component.
 * This is the main home view for MSR3 (MyScreenRights v3).
 */
const Home = () => {
  const [activeWorkspace] = useActiveWorkspace();
  const isEmbeddingWorkflow = useEmbeddedWorkflowActive();
  const { workspaceId } = useParams();

  return (
    <MSR3BaseLayout
      classes={{
        childrenWrapper: 'space-y-10',
      }}
      pageHeader={
        <PageHeader
          title={activeWorkspace?.workspaceName ?? 'Home'}
          actions={<HomeActions />}
        />
      }
    >
      {isEmbeddingWorkflow ? (
        <EmbeddedWorkflowView />
      ) : (
        <>
          <div className="!mt-3 space-y-3">
            <AlertTermsConditions />

            <AlertOnboarding />

            <AlertForUnverifiedBusinessNumber />

            <AlertConfirmClientsForWorkspace />
          </div>

          {/* Same flag the /titles route enforces, so this section cannot
              outlive the destinations its "View All" and card links go to. */}
          <IfFeatureEnabledMSR3
            name={FEATURE_FLAGS.MSR3_TITLE_PAGE_ROUTE}
            isEnabled="true"
          >
            {/* Same permission the /titles route enforces, so a user without
                it sees no section rather than an error block. */}
            <ProtectElement
              permissionRequired={[PermissionEnum.ViewTitles]}
              workspaceId={workspaceId}
            >
              {/* `/workspace/A` and `/workspace/B` are the same route element,
                  so switching workspace does not remount this on its own, and
                  the titles query's `placeholderData: keepPreviousData` keeps
                  A's titles painted while B's fetch is in flight. Keying on
                  workspaceId forces the remount: without it, a card rendered
                  in that window links B's workspaceId to A's title id (and
                  A's owner-client lookup), opening a title that isn't B's. */}
              <TitlesSnapshot key={workspaceId} />
            </ProtectElement>
          </IfFeatureEnabledMSR3>

          <PotentialClaimsSnapshot />

          <CompetingClaimsSnapshot />

          <DraftRegistrationSnapshot />
        </>
      )}
    </MSR3BaseLayout>
  );
};

export { Home };
